import { Component } from '@angular/core';

/** Loading placeholder shaped like this page: the chart card and four tiles. */
@Component({
  selector: 'ifbp-trend-metrics-skeleton',
  templateUrl: './trend-metrics-skeleton.component.html',
  styleUrls: ['./trend-metrics-skeleton.component.scss'],
  standalone: false,
})
export class TrendMetricsSkeletonComponent {
  readonly tiles = [0, 1, 2, 3];
  readonly chartTheme = { height: '21.75rem', 'border-radius': '0.5rem', margin: 0 };
  readonly tileTheme = { height: '8rem', 'border-radius': '1rem', margin: 0 };

  trackByIndex(index: number): number {
    return index;
  }
}
